// extracted by mini-css-extract-plugin
export var actionButton = "_7w-1";
export var actionButtons = "_7w-2";
export var actions = "_7w-0";
export var aiUnread = "_7w-10";
export var alignCenter = "_7w-h";
export var backWrapper = "_7w-3";
export var cellContainer = "_7w-4";
export var checkboxContainer = "_7w-5";
export var contentContainer = "_7w-6";
export var contentHeader = "_7w-8";
export var conversationsTableWrapper = "_7w-s";
export var draftReplyBadgeContainer = "_7w-m";
export var dropdownItem = "_7w-b";
export var dropdownItemsContainer = "_7w-a";
export var dropdownTitle = "_7w-c";
export var errorIcon = "_7w-7";
export var filter = "_7w-d";
export var gray = "_7w-i";
export var headerActionButtons = "_7w-e";
export var headerCheckboxContainer = "_7w-f";
export var icon = "_7w-j";
export var menuContainer = "_7w-k";
export var noMoreTicketsIcon = "_7w-12";
export var noMoreTicketsSubText = "_7w-13";
export var oneLine = "_7w-l";
export var optionsButton = "_7w-n";
export var plus = "_7w-o";
export var portalButtonsWrapper = "_7w-g";
export var red = "_7w-p";
export var scrolledTop = "_7w-9";
export var search = "_7w-q";
export var selectedConversationsCount = "_7w-r";
export var spinner = "_7w-t";
export var strong = "_7w-u";
export var summaryCell = "_7w-v";
export var tableContainer = "_7w-11";
export var tagContainer = "_7w-w";
export var threeDots = "_7w-x";
export var twoLines = "_7w-y";
export var unread = "_7w-z";